import { CompleteRegisterFormData } from './types';

export const errorMap: Partial<Record<keyof CompleteRegisterFormData, string>> =
  {
    email: 'emailAlreadyExists',
    mobileNumber: 'mobileAlreadyExists'
  };
